import {
  UseMutationOptions,
  UseQueryOptions,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query"
import { IActivity, IExtEvent } from "./types"
import api from "services/api"

export function useToSubscribeActivities(
  memberId: string,
  params?: any,
  config?: UseQueryOptions<IActivity[]>
) {
  return useQuery<IActivity[]>(
    [
      "operation",
      "administration",
      "members",
      "portal",
      memberId,
      "activities",
      params,
    ],
    {
      ...config,
    }
  )
}

export function useExtEvents(
  memberId: string,
  params: IPaginationParams & any,
  config?: UseQueryOptions<IExtEvent[]>
) {
  return useQuery<IExtEvent[]>(
    [
      "operation",
      "administration",
      "members",
      "portal",
      memberId,
      "events",
      params,
    ],
    {
      ...config,
    }
  )
}

export function useAddActivityEventsToCart(
  { memberId, activityId }: { memberId: string; activityId: string },
  config?: UseMutationOptions<unknown, unknown, { session_id: string }>
) {
  const queryClient = useQueryClient()
  return useMutation<unknown, unknown, { session_id: string }>(
    (data) =>
      api.post(
        `operation/administration/members/portal/${memberId}/presubscriptions/activity/${activityId}`,
        data
      ),
    {
      ...config,
      onSuccess(data, vars, context) {
        config?.onSuccess?.(data, vars, context)
        queryClient.invalidateQueries([
          "operation",
          "administration",
          "members",
          "portal",
          memberId,
          "activities",
        ])
      },
    }
  )
}
